const DateFormat = {
  TIME_FORMAT: "HH:mm",
  DATE_FORMAT: "dd/MM/yyyy",
};

export const LOCALE = "pt";

export default Object.freeze(DateFormat);
